import { PrimitiveAtom, useAtom } from 'jotai'

import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

import ChatSettings from './SelectSettingsOption'

const Container = () => {
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)

    return <ChatSettings processingStrategy={chatSettings?.processingStrategy} />
}

export default Container
